import { Button, TextField } from '@material-ui/core';
import React, { useCallback, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { ReactComponent as LogoWithTextSVG } from '~/assets/img/logo-with-text.svg';
import css from './styles.module.scss';

interface SignInFormProps {
    action: (p: { email: string; password: string }) => Promise<any>;
}

export const SignInForm: React.FC<SignInFormProps> = ({ action }) => {
    const { handleSubmit, register, errors } = useForm();

    const [isSigning, setSigning] = useState(false);

    const onSubmit = useCallback(
        async (data: { email: string; password: string }) => {
            setSigning(true);
            await action(data);
            setSigning(false);
        },
        [action]
    );

    const formSubmit = useMemo(() => handleSubmit(onSubmit), [handleSubmit, onSubmit]);

    return (
        <div className={css.module}>
            <LogoWithTextSVG className={css.logo} />
            <form className={css.form} onSubmit={formSubmit}>
                <TextField
                    name={'email'}
                    label={'Email'}
                    inputRef={register({ required: 'Email is required' })}
                    fullWidth
                    type={'email'}
                    autoFocus
                />
                <p className={css.error}>{errors.email?.message}</p>
                <TextField
                    name={'password'}
                    label={'Password'}
                    inputRef={register({ required: 'Password is required' })}
                    fullWidth
                    type={'password'}
                    autoFocus
                />
                <p className={css.error}>{errors.password?.message}</p>
                <Button className={css.submitButton} type={'submit'} disabled={isSigning} fullWidth>
                    Sign in
                </Button>
            </form>
        </div>
    );
};
